var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUggULogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.226 2.696v18.097c-1.806 1.02-3.7 1.536-5.632 1.536-1.932 0-3.826-.516-5.632-1.536V2.696L0 4.448v18.519l.883.59c2.674 1.788 5.686 2.733 8.711 2.733 3.025 0 6.037-.945 8.712-2.733l.882-.59V4.448l-3.962-1.752z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.493 0L7.512.876v12.966a7.164 7.164 0 001.98.284c.664 0 1.326-.095 1.982-.284V.876L9.493 0z",
    fill: "#3273FA"
  })));
}
export default __webpack_public_path__ + "static/_/_/ugg/shared/assets/svg/logos/ugg-u-logo.svg";
export { SvgUggULogo as ReactComponent };